import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { toast } from "react-toastify";
import { hubApi } from "../api.js";

export default function LoginPage() {
  const nav = useNavigate();
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await hubApi.login({ email, password });
      if (data.success) { toast.success("Cod trimis pe email!"); setStep(2); }
      else toast.error(data.message || "Credențiale incorecte.");
    } catch { toast.error("Nu s-a putut contacta serverul."); }
    finally { setLoading(false); }
  };

  const handleOtp = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await hubApi.verifyOtp({ email, otp });
      if (data.success) {
        localStorage.setItem("hubToken", data.token);
        window.location.href = "/";
      } else {
        toast.error(data.message || "Cod incorect.");
        // If OTP expired or too many attempts, go back to re-request a new code
        if (data.message && (data.message.includes("expired") || data.message.includes("attempts"))) {
          setOtp("");
          setStep(1);
        }
      }
    } catch {
      toast.error("Eroare la verificare. Încearcă din nou.");
      setOtp("");
      setStep(1);
    }
    finally { setLoading(false); }
  };

  return (
    <div style={{ minHeight: "100vh", display: "flex", background: "#f8fafc" }}>
      {/* Left */}
      <div style={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center", padding: "48px 32px" }}>
        <div style={{ width: "100%", maxWidth: 360 }}>
          {/* Logo */}
          <div style={{ marginBottom: 40 }}>
            <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 28 }}>
              <div style={{ width: 36, height: 36, borderRadius: 10, background: "linear-gradient(135deg,#1d4ed8,#3b82f6)", display: "flex", alignItems: "center", justifyContent: "center" }}>
                <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M3 9l9-7 9 7v11a2 2 0 01-2 2H5a2 2 0 01-2-2z"/><polyline points="9 22 9 12 15 12 15 22"/></svg>
              </div>
              <span style={{ fontWeight: 800, fontSize: 18, color: "#0f172a", letterSpacing: "-0.3px" }}>Orderly <span style={{ color: "#1d4ed8" }}>Hub</span></span>
            </div>
            <h1 style={{ fontSize: 22, fontWeight: 800, color: "#0f172a", margin: "0 0 6px", letterSpacing: "-0.4px" }}>
              {step === 1 ? "Bun venit înapoi" : "Verifică emailul"}
            </h1>
            <p style={{ color: "#64748b", fontSize: 14, margin: 0, lineHeight: 1.5 }}>
              {step === 1 ? "Autentifică-te în panoul de control" : `Am trimis un cod de 6 cifre la ${email}`}
            </p>
          </div>

          <AnimatePresence mode="wait">
            {step === 1 ? (
              <motion.form key="s1" onSubmit={handleLogin}
                initial={{ opacity: 0, x: -16 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: 16 }}
                transition={{ duration: 0.2 }}
                style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                <Field label="Email" type="email" value={email} onChange={setEmail} placeholder="andrei@orderly.ro" />
                <Field label="Parolă" type="password" value={password} onChange={setPassword} placeholder="••••••••" />
                <Btn loading={loading}>Continuă →</Btn>
              </motion.form>
            ) : (
              <motion.form key="s2" onSubmit={handleOtp}
                initial={{ opacity: 0, x: 16 }} animate={{ opacity: 1, x: 0 }} exit={{ opacity: 0, x: -16 }}
                transition={{ duration: 0.2 }}
                style={{ display: "flex", flexDirection: "column", gap: 16 }}>
                <div>
                  <label style={{ fontSize: 13, fontWeight: 600, color: "#374151", display: "block", marginBottom: 8 }}>Cod de verificare</label>
                  <input type="text" maxLength={6} value={otp} onChange={e => setOtp(e.target.value.replace(/\D/g, ""))}
                    placeholder="000000" autoFocus
                    style={{ width: "100%", padding: "14px", borderRadius: 10, border: "1px solid #e2e8f0", background: "#fff", fontSize: 24, fontWeight: 700, letterSpacing: 14, textAlign: "center", outline: "none", color: "#0f172a", fontFamily: "monospace", boxSizing: "border-box" }}
                    onFocus={e => e.target.style.borderColor = "#1d4ed8"}
                    onBlur={e => e.target.style.borderColor = "#e2e8f0"} />
                </div>
                <Btn loading={loading}>Verifică codul</Btn>
                <button type="button" onClick={() => setStep(1)}
                  style={{ background: "none", border: "none", color: "#94a3b8", fontSize: 13, cursor: "pointer", padding: "4px 0" }}>
                  ← Înapoi
                </button>
              </motion.form>
            )}
          </AnimatePresence>
        </div>
      </div>

      {/* Right panel */}
      <div style={{ width: 440, background: "linear-gradient(145deg,#1d4ed8 0%,#1e3a8a 40%,#7c3aed 100%)", display: "flex", flexDirection: "column", justifyContent: "center", padding: "60px 48px", position: "relative", overflow: "hidden" }}>
        {/* decorative circles */}
        <div style={{ position: "absolute", top: -80, right: -80, width: 300, height: 300, borderRadius: "50%", background: "rgba(255,255,255,0.05)" }} />
        <div style={{ position: "absolute", bottom: -60, left: -60, width: 240, height: 240, borderRadius: "50%", background: "rgba(255,255,255,0.05)" }} />

        <div style={{ position: "relative" }}>
          <p style={{ color: "rgba(255,255,255,0.6)", fontSize: 12, fontWeight: 700, letterSpacing: "1.5px", textTransform: "uppercase", marginBottom: 16 }}>Panou super-admin</p>
          <h2 style={{ color: "#fff", fontSize: 28, fontWeight: 800, lineHeight: 1.3, letterSpacing: "-0.5px", marginBottom: 12 }}>
            Controlează tot ecosistemul Orderly
          </h2>
          <p style={{ color: "rgba(255,255,255,0.65)", fontSize: 15, lineHeight: 1.7, marginBottom: 40 }}>
            Gestionează restaurante, facturi și abonamente dintr-un singur loc.
          </p>

          <div style={{ display: "flex", flexDirection: "column", gap: 14 }}>
            {["Activare / dezactivare restaurante", "Upload facturi PDF direct", "Schimbare planuri și funcționalități", "Vizualizare status billing în timp real"].map((f, i) => (
              <div key={i} style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <div style={{ width: 22, height: 22, borderRadius: "50%", background: "rgba(255,255,255,0.15)", display: "flex", alignItems: "center", justifyContent: "center", flexShrink: 0 }}>
                  <svg width="11" height="11" viewBox="0 0 12 12" fill="none"><path d="M2 6l3 3 5-5" stroke="white" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/></svg>
                </div>
                <span style={{ color: "rgba(255,255,255,0.85)", fontSize: 14 }}>{f}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

function Field({ label, type, value, onChange, placeholder }) {
  return (
    <div>
      <label style={{ fontSize: 13, fontWeight: 600, color: "#374151", display: "block", marginBottom: 7 }}>{label}</label>
      <input type={type} required value={value} onChange={e => onChange(e.target.value)} placeholder={placeholder}
        style={{ width: "100%", padding: "10px 13px", borderRadius: 9, border: "1px solid #e2e8f0", background: "#fff", fontSize: 14, outline: "none", color: "#0f172a", boxSizing: "border-box", transition: "border 0.15s" }}
        onFocus={e => e.target.style.borderColor = "#1d4ed8"}
        onBlur={e => e.target.style.borderColor = "#e2e8f0"} />
    </div>
  );
}

function Btn({ loading, children }) {
  return (
    <button type="submit" disabled={loading}
      style={{ padding: "11px", borderRadius: 9, border: "none", background: loading ? "#93c5fd" : "#1d4ed8", color: "#fff", fontWeight: 700, fontSize: 14, cursor: loading ? "not-allowed" : "pointer", display: "flex", alignItems: "center", justifyContent: "center", gap: 8, transition: "background 0.15s" }}>
      {loading ? <><Spinner /> Se procesează...</> : children}
    </button>
  );
}

function Spinner() {
  return <svg style={{ animation: "spin 0.8s linear infinite" }} width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="white" strokeWidth="2.5" strokeLinecap="round"><path d="M21 12a9 9 0 11-6.219-8.56"/></svg>;
}
